import { render, staticRenderFns } from "./DemoEnvironmentNotice.vue?vue&type=template&id=85e6837e&"
import script from "./DemoEnvironmentNotice.vue?vue&type=script&lang=js&"
export * from "./DemoEnvironmentNotice.vue?vue&type=script&lang=js&"
import style0 from "./DemoEnvironmentNotice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports